import script from "./ButtonPrimaryDiscord.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPrimaryDiscord.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPrimaryDiscord.vue?vue&type=style&index=0&id=0f51e4a7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f51e4a7"]])

export default __exports__